/** @format */

import type { BaseSystemResult } from './model';
import type { BaseResponse } from '@/utils';
import { request } from '@/utils';
import * as V1 from '@/api/version-v1';

export * from './model';
/**
 * 文件上传到文件服务器
 * @param data formData
 * @returns {name,url}
 */
export function fileUpload(file, alias = '') {
	if ('V1' === window.pData.env.VITE_ENV_APP_BASE_API_VERSION) {
		return V1.fileUpload(file, alias);
	}
	const data = new FormData(); // 创建form对象
	data.append('file', file);
	data.append('folderAlias', alias);
	data.append('groupKey', '');
	return request<BaseResponse<BaseSystemResult>>({
		url: '/base/oss/file/upload',
		method: 'post',
		timeout: 0,
		data,
	});
}
